// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Switch from "react-input-switch";
import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import Colors from "../../constants/Colors";

type Props = {
  id: string;
  activeKey?: string;
  inactiveKey?: string;
  intl?: intlShape;
  onChange: $TSFixMeFunction;
  disabled?: boolean;
  status: boolean;
  headerKey?: string;
  isMainHeaderActive?: boolean;
};

function ControlledSwitchButton(
  {
    id,
    onChange,
    activeKey,
    inactiveKey,
    intl,
    disabled,
    status,
    headerKey,
    isMainHeaderActive = true,
  }: Props,
  isEventPropagate: $TSFixMe,
) {
  const labelKey = status ? activeKey : inactiveKey;
  return (
    <div>
      <h2 hidden={!isMainHeaderActive} id="switch-title">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {intl.formatMessage({ id: headerKey })}
      </h2>
      <div hidden={isMainHeaderActive}>
        <label
          style={{
            fontWeight: 600,
            fontSize: 20,
          }}
          id="switch-title"
        >
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {intl.formatMessage({ id: headerKey })}
        </label>
        <br />
      </div>
      <Switch
        id={id}
        role="switch" // To identify the element for test cases
        aria-checked="false"
        value={status}
        on
        off={false}
        disabled={disabled}
        styles={{
          container: {
            width: 50,
            height: 28,
          },
          track: {
            borderRadius: 14,
            backgroundColor: Colors.EH_RED_ORANGE_3,
          },
          trackChecked: {
            backgroundColor: Colors.EH_MAY_GREEN_2,
          },
          button: {
            borderRadius: 18,
            right: 24,
            left: 2,
            top: 3,
            bottom: 3,
          },
          buttonChecked: {
            left: 24,
            right: 2,
            top: 3,
            bottom: 3,
          },
        }}
        onChange={() => {
          const value = status === true ? false : true; // eslint-disable-line no-unneeded-ternary
          // @ts-expect-error TS(2551) FIXME: Property 'documentMode' does not exist on type 'Do... Remove this comment to see the full error message
          if (!isEventPropagate && window.document.documentMode) {
            onChange(value);
          }

          // Normal configuration
          // @ts-expect-error TS(2551) FIXME: Property 'documentMode' does not exist on type 'Do... Remove this comment to see the full error message
          if (!window.document.documentMode) {
            onChange(value);
          }
          // added this property to fix the library issue wIth IE
          // Need to avoid propagating event in IE
          // isEventPropagate : added a lint exception, since this parameter value needs not to be reload when assigning from a local variable
          // eslint-disable-next-line no-param-reassign
          isEventPropagate = !isEventPropagate;
        }}
      />
      <div className="controlled-switch-label" id="switch-label">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {intl.formatMessage({ id: labelKey })}
      </div>
    </div>
  );
}

ControlledSwitchButton.defaultProps = {
  activeKey: "label.active",
  inactiveKey: "label.inactive",
  headerKey: "label.activation_status",
  disabled: false,
};

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(ControlledSwitchButton);
